import { h, JSX } from 'preact';
import ObservingComponent from '../componentBases/observingComponent';
import { AttendeesDayPassFieldOption } from 'core.frontend';
import AttendeesDayPassFieldProps from './attendeesDayPassFieldProps';

class AttendeesDayPassFeild extends ObservingComponent<AttendeesDayPassFieldProps> {
    private isFocusing: boolean;

    public componentWillMount(): void {
        const { AttendeesDayPassField } = this.props;
        this.registerUpdateObserver(AttendeesDayPassField.observationProvider);
        window.addEventListener('mousedown', this.blurred);
    }

    public componentWillUnmount() {
        window.removeEventListener('mousedown', this.blurred);
    }

    private attendeeOptionClicked = (eventAttendeeOption: AttendeesDayPassFieldOption) => (e: Event) => {
        e.preventDefault();
        this.props.AttendeesDayPassField.toggleSelection(eventAttendeeOption);
    };

    private dayPassToggled = (e: Event) => {
        const checked = (e.target as HTMLInputElement).checked;
        this.props.AttendeesDayPassField.toggleDayPass(checked);
    };

    public focused = (e: Event) => {
        const { AttendeesDayPassField } = this.props;
        this.isFocusing = true;
        AttendeesDayPassField.focus();
    };

    public blurred = (e: Event) => {
        const { AttendeesDayPassField } = this.props;
        if (!this.isFocusing && AttendeesDayPassField.dropdownOpen) {
            AttendeesDayPassField.blur();
        }
        this.isFocusing = false;
    };

    public render({ AttendeesDayPassField, className }: AttendeesDayPassFieldProps): JSX.Element {
        const containerStyle = {
            position: 'relative',
            width: '200px',
            cursor: 'pointer'
        };

        const boxStyle = {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '.5rem',
            borderRadius: '6px',
            backgroundColor: '#fff',
            transition: 'all 0.2s ease',
            boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.05)',
            height: '2.05rem',
            border: '1px solid #d4d4d4',
            PaddingLeft:'.5rem',
            PaddingRight:'.5rem',
            borderradius:'0.22rem',
        };

        const iconStyle = {
            fontSize: '16px',
            color: '#666',
        };

        const listStyle = {
            position: 'absolute',
            top: 'calc(100% + 4px)',
            left: 0,
            right: 0,
            border: '1px solid #ddd',
            backgroundColor: '#fff',
            borderRadius: '8px',
            maxHeight: '200px',
            overflowY: 'auto',
            zIndex: 1000,
            boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
        };

        const ulStyle = {
            listStyle: 'none',
            margin: 0,
            padding: 0,
        };

        const liStyle = (selected: boolean) => ({
            padding: '10px 12px',
            backgroundColor: selected ? '#e6f7ff' : '#fff',
            fontWeight: selected ? 600 : 400,
            display: 'flex',
            alignItems: 'center',
            transition: 'background-color 0.2s ease',
            cursor: 'pointer',
            borderBottom: '1px solid #f0f0f0',
        });

        const emptyStateStyle = {
            padding: '12px',
            color: '#999',
            textAlign: 'center',
        };

        return (
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <input
                        type="checkbox"
                        id="day-pass"
                        checked={AttendeesDayPassField.isDayPassEnabled}
                        onChange={this.dayPassToggled}
                        style={{ marginRight: '6px' }}
                    />
                    <label htmlFor="day-pass" style="font-size: .8rem;">Day Pass</label>
                </div>

                {AttendeesDayPassField.isDayPassEnabled && (
                    <div
                        style={containerStyle}
                        class={`${className} ${AttendeesDayPassField.isFocused ? 'focused' : ''} ${AttendeesDayPassField.dropdownOpen ? 'active' : ''}`}
                        onMouseDown={this.focused}
                    >
                        <div style={boxStyle}>
                            <span style="font-size: .9rem;">
                                {(() => {
                                    const selectedCount = AttendeesDayPassField.options.filter(o => o.selected).length;
                                    return selectedCount > 0 ? `${selectedCount} selected` : 'Select dates';
                                })()}
                            </span>
                            <i style={iconStyle} class="ti ti-chevron-down" />
                        </div>

                        {AttendeesDayPassField.dropdownOpen && (
                            <div style={listStyle}>
                                {AttendeesDayPassField.options.length > 0 ? (
                                    <ul style={ulStyle}>
                                        {AttendeesDayPassField.options.map((attendeeOption) => (
                                            <li
                                                onClick={this.attendeeOptionClicked(attendeeOption)}
                                                style={liStyle(attendeeOption.selected)}
                                                onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#f5f5f5')}
                                                onMouseLeave={e =>
                                                    (e.currentTarget.style.backgroundColor = attendeeOption.selected
                                                        ? '#e6f7ff'
                                                        : '#fff')
                                                }
                                            >
                                                {attendeeOption.selected && (
                                                    <i class="ti ti-check" style={{ marginRight: '8px', color: '#007acc', fontSize:'.8rem' }} />
                                                )}
                                                {attendeeOption.dayPassDate}
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <div style={emptyStateStyle}>No attendees available</div>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default AttendeesDayPassFeild;
